import { Fragment, useState } from 'react';
import { NavLink, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
// import firebase from 'firebase/app';


import { Dialog, Transition } from '@headlessui/react';
import {
    //BellIcon,
    //ChartBarIcon,
    HomeIcon,
    CogIcon,
    MenuAlt2Icon,
    // MailIcon,
    XIcon,
    DuplicateIcon,
    ArrowLeftIcon,
    UserGroupIcon
    
} from '@heroicons/react/outline';
import { DocumentTextIcon } from '@heroicons/react/solid';
import "tailwindcss/tailwind.css";

//logo
import logo from '../../../../images/bound_bleu_logo.png';

//actions
import { signOut } from '../../../../store/actions/authActions';

//functions


//components
//import ShowTokens from '../../../stripe/ShowTokens';
import ProfileCard from './components/profileCard/ProfileCard';
import LoadingSpinner from '../loadingSpinner/LoadingSpiner';

const navigation = [
    { name: 'Dashboard', href: '/', icon: HomeIcon, current: false },
    { name: 'Messages', href: '/copiedProjects', icon: DuplicateIcon, current: false },
    { name: 'Context', href: '/messaging', icon: DocumentTextIcon, current: false },
    { name: 'Contacts', href: '/contacts', icon: UserGroupIcon, current: false },
    // { name: 'Reports', href: '/report', icon: ChartBarIcon, current: false },
    { name: 'Settings', href: '/settings', icon: CogIcon, current: false },
  ]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const ContactDetails = ({auth, profile, signOut, contact}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  
  const navlinkStyle = {textDecoration: 'none'}
  if (!auth.uid) return <Redirect to='/signIn' />
  if (!auth.emailVerified) return <Redirect to='/verification' />
  return (
    <div className="h-screen flex overflow-hidden bg-gray-100">
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          static
          className="fixed inset-0 flex z-40 md:hidden"
          open={sidebarOpen}
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <div className="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-gray-800">
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute top-0 right-0 -mr-12 pt-2">
                  <button
                    className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                    onClick={() => setSidebarOpen(false)}
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </Transition.Child>
              <div className="flex-shrink-0 flex items-center px-4">
                <img
                  className="h-8 w-auto"
                  src={logo}
                  alt="Bound"
                />
              </div>
              <div className="mt-5 flex-1 h-0 overflow-y-auto">
                <nav className="px-2 space-y-1">
                  {navigation.map((item) => (
                    <NavLink
                      style={navlinkStyle}
                      key={item.name}
                      exact
                      to={item.href}
                      className={classNames(
                        item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                        'group flex items-center px-2 py-2 text-base font-medium rounded-md'
                      )}
                    >
                      <item.icon className="mr-3 h-6 w-6 text-indigo-300" aria-hidden="true" />
                      {item.name}
                    </NavLink>
                  ))}
                </nav>
              </div>
            </div>
          </Transition.Child>
          <div className="flex-shrink-0 w-14" aria-hidden="true">
            {/* Dummy element to force sidebar to shrink to fit close icon */}
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0">
        <div className="flex flex-col w-64">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex flex-col h-0 flex-1">
            <div className="flex items-center h-16 flex-shrink-0 px-4 bg-gray-900">
              <img
                className="h-8 w-auto"
                src={logo}
                alt="Bound"
              />
            </div>
            <div className="flex-1 flex flex-col overflow-y-auto">
              <nav className="flex-1 px-2 py-4 bg-gray-800 space-y-1">
                {navigation.map((item) => (
                  <NavLink
                    style={navlinkStyle}
                    key={item.name}
                    exact
                    to={item.href}
                    className={classNames(
                      item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                      'group flex items-center px-2 py-2 text-base font-medium rounded-md'
                    )}
                  >
                    <item.icon className="mr-3 h-6 w-6 text-indigo-300" aria-hidden="true" />
                    {item.name}
                  </NavLink>
                ))}

              </nav>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        <div className="relative z-10 flex-shrink-0 flex h-16 bg-white shadow">
          <button
            className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <MenuAlt2Icon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div className="flex-1 px-4 flex justify-between">
            <div className="flex-1 flex">
              <form className="w-full flex md:ml-0" action="#" method="GET">
                <label htmlFor="search_field" className="sr-only">
                  Search
                </label>
                <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                  {/* <div className="absolute inset-y-0 left-0 flex items-center pointer-events-none">
                    <SearchIcon className="h-5 w-5" aria-hidden="true" />
                  </div>
                  <input
                    id="search_field"
                    className="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm"
                    placeholder="Search"
                    type="text"
                    name="search"
                    autoComplete = 'off' 
                    onChange={(e) => searchData(e.target.value, projects, setResult)}
                  /> */}
                </div>
              </form>
            </div>
            <div className="ml-4 flex items-center gap-x-2 md:ml-6">
              {/* <button className="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                <span className="sr-only">View notifications</span>
                <BellIcon className="h-6 w-6" aria-hidden="true" />
              </button> */}
              <NavLink
              exact
              to='/profile'
              style ={{textDecoration:'none'}}
              >
                <button 
                className="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </button>
              </NavLink>
              <button 
              className="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              onClick={signOut}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              {/* <h1 className="text-2xl font-semibold text-gray-900">Details for {contact?.ProspectName}</h1> */}
              <NavLink
                exact
                //to='/contacts'
                to='/'
                style ={{textDecoration:'none', float: 'right', margin: '5px'}}
                >
                  <button
                  type="button"
                  className="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    <ArrowLeftIcon className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
                    Return
                  </button>
              </NavLink>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              {/* Replace with your content */}
              {/* <div className="py-4">
                <div className="border-4 border-dashed border-gray-200 rounded-lg h-96" />
              </div> */}
                {contact ?
                    <div style={{marginTop: '10px'}}>
                        <ProfileCard contact={contact}/>
                    </div>
                :
                    <LoadingSpinner />
                }
              {/* /End replace */}
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
    const id = ownProps.match.params.id;
    const contacts = state.firestore.data.contacts;
    const contact = contacts?.[id] 
    
    return{
        auth: state.firebase.auth,
        profile: state.firebase.profile,
        contact: contact,
        id: id,
    }
}

const mapDispatchToProps = (dispatch) => {
  return{
      signOut: (creds) => dispatch(signOut())
  }
}

export default compose (
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => {
        if (!props.profile.company) return []
        if (!props.id) return []
        return [
            // {
            //     collection: 'organizations',
            //     doc: props.profile.company,
            //     subcollections:[{ collection: "prospects", doc: props.id }],
            //     storeAs: 'contact',
            // },
            {
                collection: 'organizations',
                doc: props.profile.company,
                subcollections:[{ collection: "prospects" }],
                where: [ ['AuthorID', '==', props.auth.uid] ],
                storeAs: 'contacts',
                orderBy: ["createdAt", "desc"]
            },
        
        ]})
) (ContactDetails)